import { forwardRef, useRef } from 'react';

import { ClickAwayListener, styled } from '@material-ui/core';

import { BoxProps } from '@backstage/ui';

import { FloatingCard } from './FloatingCard';
import { useFloatingPosition } from './useFloatingPosition';

const FloatingContainer = styled('div')({
  position: 'absolute',
  zIndex: 9999,
});

type FloatingPopoverProps = BoxProps & {
  isOpen: boolean;
  onClose?: () => void;
  anchorElement: HTMLElement | null;
  closeOnClickOutside?: boolean;
};

export const FloatingPopover = forwardRef<HTMLDivElement, FloatingPopoverProps>(
  (
    {
      isOpen,
      onClose,
      anchorElement,
      children,
      closeOnClickOutside = true,
      ...boxProps
    },
    forwardedRef,
  ) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const floatingRef =
      (forwardedRef as React.RefObject<HTMLDivElement>) || internalRef;

    useFloatingPosition({
      isOpen,
      anchorElement,
      floatingRef,
    });

    if (!isOpen) return null;

    const content = (
      <FloatingContainer ref={floatingRef}>
        <FloatingCard p="2" width="300px" {...boxProps}>
          {children}
        </FloatingCard>
      </FloatingContainer>
    );

    if (closeOnClickOutside && onClose) {
      return (
        <ClickAwayListener onClickAway={onClose}>{content}</ClickAwayListener>
      );
    }

    return content;
  },
);

FloatingPopover.displayName = 'FloatingPopover';
